import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-cancel",
  "use": "icon-cancel-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-cancel\"><path d=\"M748.672 746.56a46.976 46.976 0 0 1 0 66.048 46.976 46.976 0 0 1-66.048 0l-205.44-205.44-205.568 205.44a46.976 46.976 0 0 1-66.048 0 46.976 46.976 0 0 1 0-66.048l205.44-205.504-205.376-205.44a46.976 46.976 0 0 1 0-66.048 46.976 46.976 0 0 1 66.112 0l205.44 205.44 205.312-205.44a46.976 46.976 0 0 1 66.112 0 46.976 46.976 0 0 1 0 66.048l-205.44 205.44z\" fill=\"#FF6625\" p-id=\"1851\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/cancel.svg
// module id = pdRo
// module chunks = 27